import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { tenantSiteApiClient } from '@src/api/tenant/site/tenantSiteApiClient';
import SpinnerOverlay from '@src/components/SpinnerOverlay';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function RedirectToTenantTopPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function redirectToTopPage() {
      const res = await tenantSiteApiClient.topPageUrl();
      handleApiResponse(res, (data) => {
        setLoading(false);
        navigate(data.url);
      });
    }
    redirectToTopPage();
  }, [navigate]);

  return (
    <>
      <SpinnerOverlay loading={loading} />
    </>
  );
}

export default RedirectToTenantTopPage;
